import React, { FC, Fragment } from 'react';
import { QueryResult } from 'react-apollo';
import { Grid } from '@material-ui/core';

import { GetGroupFollowersComponent, Group, UserFeedFollow } from 'api';
import { Desktop, Mobile, Layouts, QueryManager, UserCard } from 'components';

import { DesktopBanner, FeedMenu, MobileBanner } from './Group';

interface IProps {
  group: Group;
  isFollowing: boolean;
}

const GroupMembers: FC<IProps> = props => {
  const { group, isFollowing } = props;

  function renderMenu() {
    return <FeedMenu selectedGroup={group} />;
  }

  function renderFollowers(queryProps: QueryResult) {
    const { data } = queryProps;

    if (!data) {
      return null;
    }

    const { feedFollowing } = data;
    const { feed_follows } = feedFollowing;

    return (
      <Grid container spacing={2}>
        {feed_follows.map(({ followed_by_user }: UserFeedFollow) => (
          <UserCard key={followed_by_user.id} user={followed_by_user} />
        ))}
      </Grid>
    );
  }

  function renderMain() {
    return (
      <GetGroupFollowersComponent variables={{ id: group.id, limit: 50 }}>
        {queryProps => (
          <QueryManager {...queryProps}>{() => renderFollowers(queryProps)}</QueryManager>
        )}
      </GetGroupFollowersComponent>
    );
  }

  function renderBanner() {
    const bannerProps = {
      group,
      menu: renderMenu(),
    };

    return (
      <Fragment>
        <Desktop>
          <DesktopBanner {...bannerProps} />
        </Desktop>
        <Mobile>
          <MobileBanner isFollowing={isFollowing} {...bannerProps} />
        </Mobile>
      </Fragment>
    );
  }

  return <Layouts.AppMain1Column header={renderBanner()} main={renderMain()} />;
};

export default GroupMembers;
